import axios from 'axios'
// initial state
const state = {
  user: {
    sellerId: '',
    companyName: '',
    companyNameEiji: '',
    sellerName: '',
    sellerNameEiji: '',
    sellerTel: '',
    promotionFlg: '',
    multiChannelSenderFlg: '0',
    memo: null,
    offerPriceRate: null,
    countryCode: '',
    countryName: '',
    stateCode: '',
    stateName: '',
    chatWorkFlg: '',
    danboardFlg: '',
    noticeEmail: '',
    isNoticeEmail: null,
    version: null,
    invalidSettingSpAccount: false,
    hasSpAccount: false,
    enableFlag: null,
    expireAt: null,
    amazonMerchantId: '',
    canGetLatestProducts: '',
    getLatestProductsDate: '',
    nextGetLatestProductsDate: '',
    isSellerInfoUpdated: false,
    zipCode: '',
    address: '',
    telNo: '',
    variationDisplaySetting: '0',
    reportCreationDate: null,
    showModalGetProductLatest: false,
    memberPlan: '',
    yamatoWarehouseUse: '',
    offerPriceSalmonDiff: '',
    offerPriceSalmonDiffSetting: '',
    offerPriceAcrossDiff: '',
    offerPriceAcrossDiffSetting: '',
    acrossAgreeFlg: '',
    maintenanceFlg: ''
  },
  loginStatus: ''
}

// getters
const getters = {
  getUser: state => state.user,
  getStatus: state => state.loginStatus
}

// actions
const actions = {
  // how to call: store.dispatch('doLogout')
  doLogout (context) {
    localStorage.removeItem('tokenSalmon')
    context.commit('userInit')
    context.commit('doAuthenticated', false)
    context.commit('saveResultCode', null)
    delete axios.defaults.headers.common['Authorization']
  }
}

// mutations
const mutations = {
  userInit (state) {
    state.user.userName = ''
    state.user.role = ''
    state.loginStatus = ''
    state.user.companyName = ''
    state.user.companyNameEiji = ''
    state.user.sellerName = ''
    state.user.sellerNameEiji = ''
    state.user.sellerId = ''
    state.user.sellerTel = ''
    state.user.promotionFlg = ''
    state.user.multiChannelSenderFlg = '0'
    state.user.countryCode = ''
    state.user.countryName = ''
    state.user.stateCode = ''
    state.user.stateName = ''
    state.user.chatWorkFlg = ''
    state.user.danboardFlg = ''
    state.user.memo = null
    state.user.offerPriceRate = null
    state.user.noticeEmail = ''
    state.user.isNoticeEmail = null
    state.user.invalidSettingSpAccount = false
    state.user.hasSpAccount = false
    state.user.enableFlag = null
    state.user.expireAt = null
    state.user.amazonMerchantId = ''
    state.user.canGetLatestProducts = ''
    state.user.getLatestProductsDate = ''
    state.user.nextGetLatestProductsDate = ''
    state.user.zipCode = ''
    state.user.address = ''
    state.user.telNo = ''
    state.user.isSellerInfoUpdated = ''
    state.user.variationDisplaySetting = '0'
    state.user.reportCreationDate = null
    state.user.showModalGetProductLatest = false
    state.user.memberPlan = ''
    state.user.yamatoWarehouseUse = ''
    state.user.offerPriceSalmonDiff = ''
    state.user.offerPriceSalmonDiffSetting = ''
    state.user.offerPriceAcrossDiff = ''
    state.user.offerPriceAcrossDiffSetting = ''
    state.user.acrossAgreeFlg = ''
    state.user.maintenanceFlg = ''
  },
  setUser (state, user) {
    state.user.sellerId = user.sellerId
    state.user.companyName = user.companyName
    state.user.companyNameEiji = user.companyNameEiji
    state.user.sellerName = user.sellerName
    state.user.sellerNameEiji = user.sellerNameEiji
    state.user.sellerTel = user.sellerTel
    state.user.promotionFlg = user.promotionFlg
    state.user.multiChannelSenderFlg = user.multiChannelSenderFlg
    state.user.memo = user.memo
    state.user.offerPriceRate = user.offerPriceRate
    state.user.countryCode = user.countryCode
    state.user.countryName = user.countryName
    state.user.stateCode = user.stateCode
    state.user.stateName = user.stateName
    state.user.chatWorkFlg = user.chatWorkFlg
    state.user.danboardFlg = user.danboardFlg
    state.user.noticeEmail = user.noticeEmail
    state.user.isNoticeEmail = user.isNoticeEmail
    if (!state.user.version) {
      state.user.version = user.version
    }
    state.user.invalidSettingSpAccount = user.invalidSettingSpAccount
    state.user.hasSpAccount = user.hasSpAccount
    state.user.enableFlag = user.enableFlag
    state.user.expireAt = user.expireAt
    state.user.amazonMerchantId = user.amazonMerchantId
    state.user.canGetLatestProducts = user.can_get_latest
    state.user.getLatestProductsDate = user.get_latest_date
    state.user.nextGetLatestProductsDate = user.next_get_latest_date
    state.user.zipCode = user.zipCode
    state.user.address = user.address
    state.user.telNo = user.telNo
    state.user.isSellerInfoUpdated = user.isSellerInfoUpdated
    state.user.variationDisplaySetting = user.variationDisplaySetting
    state.user.reportCreationDate = user.reportCreationDate
    state.user.showModalGetProductLatest = user.showModalGetProductLatest
    state.user.memberPlan = user.memberPlan
    state.user.yamatoWarehouseUse = user.yamatoWarehouseUse
    state.user.offerPriceSalmonDiff = user.offerPriceSalmonDiff
    state.user.offerPriceSalmonDiffSetting = user.offerPriceSalmonDiffSetting
    state.user.offerPriceAcrossDiff = user.offerPriceAcrossDiff
    state.user.offerPriceAcrossDiffSetting = user.offerPriceAcrossDiffSetting
    state.user.acrossAgreeFlg = user.acrossAgreeFlg
    state.user.maintenanceFlg = user.maintenanceFlg
  },
  setStatus (state, status) {
    state.loginStatus = status
  },
  setVersion (state, version) {
    state.user.version = version
  },
  setSellerUpdatedRegisterInfo (state) {
    state.user.isSellerInfoUpdated = true
  },
  setVariationDisplaySetting (state, variationDisplaySetting) {
    state.user.variationDisplaySetting = variationDisplaySetting
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js